module.exports = __webpack_public_path__ + "img/ba19fcc.jpg";